import React, {Component} from 'react'
import './RecordListTable.css'
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import RecordStyledTableHead from './RecordStyledTableHead';
import RecordStyledTableBody from './RecordStyledTableBody';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
//import ContextMenu from '../../FunctionArea/ContextMenu'


const wStyles = theme => ({
    TableContainerNotFullScreen: {
       height:"70vh"
    },
    TableContainerFullScreen: {
        height:"100%"
     },
})

class RecordListTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataState:0,
            //listData:[],
            orderColumn:null,
            orderType:null,   
            tableWidth:420
        }
    }

    componentDidMount(){
       this.refreshState()
    }

    componentDidUpdate(prevProps,prevState){
        let thisWidth = this.getTableWidthNumber(this.props.columnStatus)
        if(prevProps.storedOrderColumn !== this.state.orderColumn || prevProps.storedOrderType !== this.state.orderType || this.state.tableWidth !== thisWidth) 
        {
            this.refreshState(thisWidth)
        }
    }

    refreshState=(width)=>{       
        this.setState({
            tableWidth:width,
            orderColumn:this.props.storedOrderColumn,
            orderType:this.props.storedOrderType
        })    
    }
    
    handleRecordListClicked = (msg) => {

        this.props.getSelectedRecord(msg)
        
    }

    toggleMovieMount=(msg)=>{
        //console.log("toggleMovieMount")
        //console.log(msg)
        this.props.toggleMountOrUnmount(msg)
    }

    getNewOrderStatus = (msg) => {
        console.log(msg)
        if(msg === this.state.orderColumn)
        {
            if(this.state.orderType === "ASC")
            {
                this.setState({
                    orderType:"DESC"
                })

                let sentMsg={
                    orderColumn:msg,
                    orderType:"DESC"
                }
                this.props.getOrderStatus(sentMsg)
            }
            else
            {
                this.setState({
                    orderType:"ASC"
                })

                let sentMsg={
                    orderColumn:msg,
                    orderType:"ASC"
                }
                this.props.getOrderStatus(sentMsg)
            }
        }
        else
        {
            this.setState({
                orderColumn:msg,
                orderType:"ASC"
            })

            let sentMsg={
                orderColumn:msg,
                orderType:"ASC"
            }
            this.props.getOrderStatus(sentMsg)
        }
    }

    getTableWidthNumber=(columnStatus)=>{
        let widthNumber = 420
        if(columnStatus)
        {
            columnStatus.forEach(element => {
                if(element.status)
                {
                    widthNumber = widthNumber + element.width
                }
            });
        }
        return widthNumber
    }

    getTableWidth=()=>{
        let style = {
            width:this.state.tableWidth+'px'
        }
        return style
    }

    render(){
        //let text = this.state.listData[0]?this.state.listData[0].Event_Title:"Not Ready"
        const {classes} = this.props;
        console.log("RecordListTable Render")

        return(
            
            <TableContainer className={this.props.fullScreen?classes.TableContainerFullScreen:classes.TableContainerNotFullScreen} component={Paper}>
                <Table style={this.getTableWidth()} aria-label="customized table" stickyHeader>
                    <RecordStyledTableHead orderColumn={this.state.orderColumn} orderType={this.state.orderType} columnStatus={this.props.columnStatus} getNewOrderStatus={this.getNewOrderStatus} openColumnSelectedModal={()=>this.props.openColumnSelectedModal(true)} toggleMountOrUnmount={()=>this.props.toggleMountOrUnmount()}/>
                    <RecordStyledTableBody listData={this.props.listData} columnStatus={this.props.columnStatus} limitNumber={this.props.limitNumber} pageNumber={this.props.pageNumber} handleRecordListClicked={this.handleRecordListClicked} toggleMovieMount={this.toggleMovieMount} keywords={this.props.keywords}/>              
                </Table>
            </TableContainer>
        )
    }

}

export default withStyles(wStyles)(RecordListTable)